import ImageEditForm from './image-edit-form';
import { Props } from './image.constants';

const ImageEditDrawer = (props: Props) => <ImageEditForm {...props} />;

export default ImageEditDrawer;
